/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetExternalOrderStatuses() {
  const response = await $.soap({
    body: {
      GetExternalOrderStatuses: {
        $xmlns: 'http://dla.mil/ems/db/lookup/lu_order_status'
      }
    },
    blueprintArrays: ['GetExternalOrderStatusesResponse.tuple'],
    blueprint: {
      status: [
        '$..GetExternalOrderStatusesResponse.tuple',
        {
          id: '$.old.LU_OrderStatus.ID',
          externalOrderStatus: '$.old.LU_OrderStatus.ExternalOrderStatus'
        }
      ]
    }
  });
  cleanUpResponse(response);
  const filteredArr = response.status.reduce((acc, current) => {
    const x = acc.find((item) => item.externalOrderStatus === current.externalOrderStatus);
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []);
  return filteredArr;
}
